import type {
	ListSignatureRequestTemplatesResponseJSON,
	SignatureRequestTemplateSortBy,
} from "@performyard/service-contracts";

import legacyRequest from "../base-request";
import request from "./internal-api/internal-base-request";

export type { SignatureRequestTemplateSortBy };

export type ListSignatureRequestTemplatesParams = {
	name?: string;
	sortBy?: SignatureRequestTemplateSortBy;
	sortOrder?: "asc" | "desc";
	limit?: number;
	skip?: number;
};

export const getSignatureRequestTemplates = async (
	params: ListSignatureRequestTemplatesParams = {}
): Promise<ListSignatureRequestTemplatesResponseJSON> => {
	const searchParams = new URLSearchParams();
	if (params.name) searchParams.set("name", params.name);
	if (params.sortBy) searchParams.set("sortBy", params.sortBy);
	if (params.sortOrder) searchParams.set("sortOrder", params.sortOrder);
	if (params.limit !== undefined) searchParams.set("limit", String(params.limit));
	if (params.skip !== undefined) searchParams.set("skip", String(params.skip));

	const query = searchParams.toString();
	const [response] = await request<ListSignatureRequestTemplatesResponseJSON>(
		`/v1/signature-request-templates${query ? `?${query}` : ""}`,
		{ method: "GET" }
	);
	return response;
};

/** Wildcard signer references as the legacy API returns them ("self" | "manager" | "other") or a user id. */
export type SignatureRequestTemplateSignerJSON = {
	signer: string | null;
	fields: string[];
};

export type SignatureRequestTemplateDetailJSON = {
	id: string;
	name: string;
	documentID: string;
	signers: SignatureRequestTemplateSignerJSON[];
};

/**
 * Detail read stays on the legacy tornado endpoint — the internal-api list above has no
 * signer/step data, and this is what the workflow template editor shows as
 * "Signature Steps" for an attached template.
 */
export const getSignatureRequestTemplateDetail = async (
	templateId: string
): Promise<SignatureRequestTemplateDetailJSON> => {
	const [response] = await legacyRequest<SignatureRequestTemplateDetailJSON>(
		`/api/signature-templates/${templateId}/`,
		{ method: "GET" }
	);
	return response;
};
